import axios from "axios";
import { HOST_URL } from "./Host";

export const SET_CARD_PAYMENT = "SET_CARD_PAYMENT";
export const SET_PAYMENT_FROM = "SET_PAYMENT_FROM";

const headers = {
  Accept: "application/json",
  "Content-Type": "application/json",
  "X-Accept-Version": "2.0",
};

export function setCardPayment(cardPayment) {
  return {
    type: SET_CARD_PAYMENT,
    payload: cardPayment,
  };
}

export const setPaymentFrom = (paymentFrom) => ({
  type: SET_PAYMENT_FROM,
  payload: paymentFrom,
});

export function mobilePayment(token, paymentData, callback) {
  return async () => {
    try {
      const response = await axios.post(
        `${HOST_URL}/payments/mobile`,
        paymentData,
        {
          headers: {
            ...headers,
            Authorization: `Bearer ${token}`,
          },
        }
      );

      callback({
        success: true,
        data: response.data.data,
        message: response.data.message,
      });
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      // Vérifier si l'erreur provient d'une réponse HTTP
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        // Vérifier si une autre description d'erreur est disponible
        errorMessage = error.message;
      }

      callback({
        success: false,
        message: errorMessage,
      });
    }
  };
}

export function cardPayment(token, paymentData, callback) {
  return async (dispatch) => {
    try {
      const response = await axios.post(
        `${HOST_URL}/payments/card`,
        paymentData,
        {
          headers: {
            ...headers,
            Authorization: `Bearer ${token}`,
          },
        }
      );

      await dispatch(setCardPayment(response.data.data));
      await callback({
        success: true,
        data: response.data.data,
        message: response.data.message,
      });
    } catch (error) {
      let errorMessage = "Une erreur inattendue est survenue.";

      // Vérifier si l'erreur provient d'une réponse HTTP
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        // Vérifier si une autre description d'erreur est disponible
        errorMessage = error.message;
      }

      callback({
        success: false,
        message: errorMessage,
      });
    }
  };
}

export function checkPayment(
  token,
  reference,
  request,
  callback,
  attempts = 100,
  // Polling stops as soon as this returns false (page left)
  isActive = () => true,
) {
  return async () => {
    const checkStatus = async (attempt = 0, maxAttempts = attempts) => {
      if (!isActive()) return;

      try {
        const response = await axios.get(
          `${HOST_URL}/payments/check?reference=${reference}${
            request ? `&request=${request}` : ""
          }`,
          {
            headers: {
              ...headers,
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const status = response.data.data.status;

        if (status === "completed") {
          // Paiement réussi
          callback({
            success: true,
            message: "Paiement validé avec succès.",
          });
        } else if (status === "initiated" && attempt < maxAttempts) {
          // Relancer après un délai si le statut est "initiated"
          setTimeout(() => checkStatus(attempt + 1, maxAttempts), 3000); // Réessayer après 3 secondes
        } else {
          // Si le statut n'est pas "paid" ou la tentative maximale est atteinte
          callback({
            success: false,
            message:
              attempt >= maxAttempts
                ? "Le paiement n'a pas pu être validé après plusieurs tentatives."
                : "Le statut du paiement est non valide.",
          });
        }
      } catch (error) {
        let errorMessage = "Une erreur inattendue est survenue.";

        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          errorMessage = error.response.data.message;
        } else if (error.message) {
          errorMessage = error.message;
        }

        callback({
          success: false,
          message: errorMessage,
        });
      }
    };

    // Lancer la première tentative de vérification
    checkStatus();
  };
}

// Payment methods the server currently offers (public)
export function getPaymentMethods(callback) {
  return async () => {
    try {
      const response = await axios.get(`${HOST_URL}/payments/methods`, {
        headers,
      });
      callback({ success: true, data: response.data.data });
    } catch (error) {
      callback({ success: false });
    }
  };
}

// Amount still to pay for a request, computed by the server
export function getPaymentQuote(token, request, callback) {
  return async () => {
    try {
      const response = await axios.get(
        `${HOST_URL}/payments/quote?request=${request}`,
        {
          headers: {
            ...headers,
            Authorization: `Bearer ${token}`,
          },
        },
      );
      callback({ success: true, data: response.data.data });
    } catch (error) {
      callback({
        success: false,
        message:
          error.response?.data?.message ||
          error.message ||
          "Une erreur inattendue est survenue.",
      });
    }
  };
}
